<template>
  <div class="section nav-section">
    <h1 class="d-none d-md-block section-header display-3 font-weight-bold py-10 mb-10">
      Timeline
    </h1>
    <h1 class="d-md-none section-header display-1 font-weight-bold mb-10">
      Timeline
    </h1>
    <div>
      <iframe
        src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1FmoRsMoP-Q0lt_lNMGaezzIm2zXuPU62te2ZdPzVyOs&font=Default&lang=en&initial_zoom=2&height=650"
        width="100%"
        height="650"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Timeline",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>